import { render, staticRenderFns } from "./ImgVisa.vue?vue&type=template&id=79d984bc&scoped=true&"
import script from "./ImgVisa.vue?vue&type=script&lang=js&"
export * from "./ImgVisa.vue?vue&type=script&lang=js&"
import style0 from "./ImgVisa.vue?vue&type=style&index=0&id=79d984bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d984bc",
  null
  
)

export default component.exports